import api from 'networkapp-api-connector';
import _ from 'lodash';

export default {
    fetchFormMetadata: function(formId) {
        return api
            .forms
            .fetchFormMetadata(formId)
            .then(data => {
                app
                    .store
                    .dispatch(app.actions.forms.loadFormMetadata(formId, data));
                return data;
            });
    },
    sendAnswer: function(answerUID, formId, answer) {
        return api
            .forms
            .sendAnswer(formId, answer)
            .then(data => {
                app
                    .store
                    .dispatch(app.actions.forms.uploadSuccess(answerUID));
            });
    },
    fetchConditionalOptions: function(questionId, answers) {
        return api
            .forms
            .fetchConditionalOptions(questionId, {"answers": answers});
    }
}
